import { HTMLAttributes } from "react";
import "./style.css";

const SectionWrapper = ({ children, className = "", ...props }: HTMLAttributes<HTMLDivElement>) => {
    return (
        <div className={`section-wrapper ${className}`} {...props}>
            {children}
        </div>
    );
};

export default SectionWrapper;
